/* tslint:disable */
/* eslint-disable */
/**
 * Intranet - Notifications API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ActionConfigAndSchemaResponseResponse } from '../models';
// @ts-ignore
import type { BooleanResponse } from '../models';
// @ts-ignore
import type { ConfigAndSchemaResponseResponse } from '../models';
// @ts-ignore
import type { ListOptionDTOSearchResponseResponse } from '../models';
// @ts-ignore
import type { ModuleActionConfigAndSchemaResponseResponse } from '../models';
// @ts-ignore
import type { ModuleActionListResponse } from '../models';
// @ts-ignore
import type { ModuleConfigAndSchemaResponseResponse } from '../models';
// @ts-ignore
import type { ModuleListResponse } from '../models';
// @ts-ignore
import type { ModuleWithActionsDTOListResponse } from '../models';
// @ts-ignore
import type { ModuleWithActionsDTOResponse } from '../models';
// @ts-ignore
import type { NotificationResponse } from '../models';
// @ts-ignore
import type { NotificationSearchResponseResponse } from '../models';
// @ts-ignore
import type { ObjectResponse } from '../models';
// @ts-ignore
import type { StringResponse } from '../models';
// @ts-ignore
import type { UpdateActionKeyConfig } from '../models';
// @ts-ignore
import type { UpdateEntireConfig } from '../models';
// @ts-ignore
import type { UpdateModuleConfig } from '../models';
/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets a list of all ModuleActions as ListOptionDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ListModuleActionGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/List/module-action`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of all modules as ListOptionDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ListModuleGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/List/module`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of ModuleActions for a specific module as ListOptionDTO
         * @param {string} module 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ListModuleModuleActionGet: async (module: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'module' is not null or undefined
            assertParamExists('apiV1ListModuleModuleActionGet', 'module', module)
            const localVarPath = `/api/v1/List/{module}/module-action`
                .replace(`{${"module"}}`, window.customEncodeURIComponent(module));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of all ModuleActions from all modules (flat structure)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ModuleActionFlatGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ModuleAction/flat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of all ModuleActions for a specific module (flat structure)
         * @param {string} module 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ModuleActionFlatModuleGet: async (module: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'module' is not null or undefined
            assertParamExists('apiV1ModuleActionFlatModuleGet', 'module', module)
            const localVarPath = `/api/v1/ModuleAction/flat/{module}`
                .replace(`{${"module"}}`, window.customEncodeURIComponent(module));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all modules with their nested actions in a hierarchical structure  Returns: Module { name, labelKey, id, isDeleted, actions: [{ actionKey, labelKey, active, id, isDeleted }] }
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ModuleActionGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ModuleAction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a specific module with its nested actions in a hierarchical structure  Returns: Module { name, labelKey, id, isDeleted, actions: [{ actionKey, labelKey, active, id, isDeleted }] }
         * @param {string} module 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ModuleActionModuleGet: async (module: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'module' is not null or undefined
            assertParamExists('apiV1ModuleActionModuleGet', 'module', module)
            const localVarPath = `/api/v1/ModuleAction/{module}`
                .replace(`{${"module"}}`, window.customEncodeURIComponent(module));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of all modules from the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ModuleGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Module`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all modules with their actions, each action containing its config and schema  Returns a hierarchical structure organized by Module -> ModuleAction -> {Config, Schema}
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ModuleGetAllActionsConfigAndSchemaGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Module/GetAllActionsConfigAndSchema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Web Socket on connect endpoint.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionConnectionsOnConnectPost: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionConnectionsOnConnectPost', 'version', version)
            const localVarPath = `/api/v{version}/Connections/onConnect`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Web Socket on disConnect endpoint.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionConnectionsOnDisconnectPost: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionConnectionsOnDisconnectPost', 'version', version)
            const localVarPath = `/api/v{version}/Connections/OnDisconnect`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a notification configuration for a specific action key
         * @param {string} version 
         * @param {UpdateActionKeyConfig} [updateActionKeyConfig] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationConfigActionPut: async (version: string, updateActionKeyConfig?: UpdateActionKeyConfig, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationConfigActionPut', 'version', version)
            const localVarPath = `/api/v{version}/NotificationConfig/action`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateActionKeyConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all notification configurations and schemas for the current tenant
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationConfigAllGet: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationConfigAllGet', 'version', version)
            const localVarPath = `/api/v{version}/NotificationConfig/all`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the entire notification configuration root
         * @param {string} version 
         * @param {UpdateEntireConfig} [updateEntireConfig] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationConfigConfigurationPut: async (version: string, updateEntireConfig?: UpdateEntireConfig, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationConfigConfigurationPut', 'version', version)
            const localVarPath = `/api/v{version}/NotificationConfig/configuration`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEntireConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets notification configuration and schema for a specific action ID
         * @param {string} module 
         * @param {string} actionId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationConfigModuleActionIdActionGet: async (module: string, actionId: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'module' is not null or undefined
            assertParamExists('apiVversionNotificationConfigModuleActionIdActionGet', 'module', module)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('apiVversionNotificationConfigModuleActionIdActionGet', 'actionId', actionId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationConfigModuleActionIdActionGet', 'version', version)
            const localVarPath = `/api/v{version}/NotificationConfig/{module}/{actionId}/action`
                .replace(`{${"module"}}`, window.customEncodeURIComponent(module))
                .replace(`{${"actionId"}}`, window.customEncodeURIComponent(actionId))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets notification configurations and schemas for a specific module
         * @param {string} module 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationConfigModuleGet: async (module: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'module' is not null or undefined
            assertParamExists('apiVversionNotificationConfigModuleGet', 'module', module)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationConfigModuleGet', 'version', version)
            const localVarPath = `/api/v{version}/NotificationConfig/{module}`
                .replace(`{${"module"}}`, window.customEncodeURIComponent(module))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates all notification configurations for an entire module
         * @param {string} version 
         * @param {UpdateModuleConfig} [updateModuleConfig] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationConfigModulePut: async (version: string, updateModuleConfig?: UpdateModuleConfig, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationConfigModulePut', 'version', version)
            const localVarPath = `/api/v{version}/NotificationConfig/module`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateModuleConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationGetAllGet: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationGetAllGet', 'version', version)
            const localVarPath = `/api/v{version}/Notification/GetAll`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get count of all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationGetCountGet: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationGetCountGet', 'version', version)
            const localVarPath = `/api/v{version}/Notification/GetCount`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get recent unread Notifications and total count of unread notifications.
         * @param {string} version 
         * @param {number} [count] How many recent notifications to get. Insert UserEntity Header (Partition Key)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationGetRecentGet: async (version: string, count?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationGetRecentGet', 'version', version)
            const localVarPath = `/api/v{version}/Notification/GetRecent`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a single notification by primary key. Sort Key (timestamp) Partition Key (user entity header)\"  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {string} [timestamp] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationKeyGet: async (version: string, timestamp?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationKeyGet', 'version', version)
            const localVarPath = `/api/v{version}/Notification/key`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timestamp !== undefined) {
                localVarQueryParameter['timestamp'] = timestamp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks all unread notifications as read
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationMarkAllAsReadPut: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationMarkAllAsReadPut', 'version', version)
            const localVarPath = `/api/v{version}/Notification/mark-all-as-read`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks one notification as read
         * @param {string} version 
         * @param {string} [body] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationMarkItemAsReadPut: async (version: string, body?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationMarkItemAsReadPut', 'version', version)
            const localVarPath = `/api/v{version}/Notification/mark-item-as-read`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks a list of notifications as read
         * @param {string} version 
         * @param {Array<string>} [requestBody] List of notifications to mark as read. Insert UserEntity Header (Partition Key). Insert timestamps (sortkeys) as list of strings. Example: [\&quot;2025-05-23T13:43:41.8220222+00:00\&quot;]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationMarkListAsReadPut: async (version: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationMarkListAsReadPut', 'version', version)
            const localVarPath = `/api/v{version}/Notification/mark-list-as-read`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Posts notifications from notification processing lambda. We use these to check for active users.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationPushNewPost: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationPushNewPost', 'version', version)
            const localVarPath = `/api/v{version}/Notification/push-new`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Notification\'s pagination. Does skip and take based on pageNum and pageSize.
         * @param {string} version 
         * @param {number} [pageNum] Insert UserEntity Header (Partition Key)
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationSkipAndTakeGet: async (version: string, pageNum?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionNotificationSkipAndTakeGet', 'version', version)
            const localVarPath = `/api/v{version}/Notification/SkipAndTake`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets a list of all ModuleActions as ListOptionDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ListModuleActionGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOptionDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ListModuleActionGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1ListModuleActionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a list of all modules as ListOptionDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ListModuleGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOptionDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ListModuleGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1ListModuleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a list of ModuleActions for a specific module as ListOptionDTO
         * @param {string} module 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ListModuleModuleActionGet(module: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOptionDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ListModuleModuleActionGet(module, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1ListModuleModuleActionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a list of all ModuleActions from all modules (flat structure)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ModuleActionFlatGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleActionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ModuleActionFlatGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1ModuleActionFlatGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a list of all ModuleActions for a specific module (flat structure)
         * @param {string} module 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ModuleActionFlatModuleGet(module: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleActionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ModuleActionFlatModuleGet(module, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1ModuleActionFlatModuleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all modules with their nested actions in a hierarchical structure  Returns: Module { name, labelKey, id, isDeleted, actions: [{ actionKey, labelKey, active, id, isDeleted }] }
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ModuleActionGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleWithActionsDTOListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ModuleActionGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1ModuleActionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a specific module with its nested actions in a hierarchical structure  Returns: Module { name, labelKey, id, isDeleted, actions: [{ actionKey, labelKey, active, id, isDeleted }] }
         * @param {string} module 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ModuleActionModuleGet(module: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleWithActionsDTOResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ModuleActionModuleGet(module, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1ModuleActionModuleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a list of all modules from the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ModuleGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ModuleGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1ModuleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all modules with their actions, each action containing its config and schema  Returns a hierarchical structure organized by Module -> ModuleAction -> {Config, Schema}
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ModuleGetAllActionsConfigAndSchemaGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleActionConfigAndSchemaResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ModuleGetAllActionsConfigAndSchemaGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1ModuleGetAllActionsConfigAndSchemaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Web Socket on connect endpoint.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionConnectionsOnConnectPost(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionConnectionsOnConnectPost(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionConnectionsOnConnectPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Web Socket on disConnect endpoint.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionConnectionsOnDisconnectPost(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionConnectionsOnDisconnectPost(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionConnectionsOnDisconnectPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates a notification configuration for a specific action key
         * @param {string} version 
         * @param {UpdateActionKeyConfig} [updateActionKeyConfig] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationConfigActionPut(version: string, updateActionKeyConfig?: UpdateActionKeyConfig, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationConfigActionPut(version, updateActionKeyConfig, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationConfigActionPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all notification configurations and schemas for the current tenant
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationConfigAllGet(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfigAndSchemaResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationConfigAllGet(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationConfigAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates the entire notification configuration root
         * @param {string} version 
         * @param {UpdateEntireConfig} [updateEntireConfig] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationConfigConfigurationPut(version: string, updateEntireConfig?: UpdateEntireConfig, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationConfigConfigurationPut(version, updateEntireConfig, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationConfigConfigurationPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets notification configuration and schema for a specific action ID
         * @param {string} module 
         * @param {string} actionId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationConfigModuleActionIdActionGet(module: string, actionId: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionConfigAndSchemaResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationConfigModuleActionIdActionGet(module, actionId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationConfigModuleActionIdActionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets notification configurations and schemas for a specific module
         * @param {string} module 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationConfigModuleGet(module: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleConfigAndSchemaResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationConfigModuleGet(module, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationConfigModuleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates all notification configurations for an entire module
         * @param {string} version 
         * @param {UpdateModuleConfig} [updateModuleConfig] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationConfigModulePut(version: string, updateModuleConfig?: UpdateModuleConfig, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationConfigModulePut(version, updateModuleConfig, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationConfigModulePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationGetAllGet(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationGetAllGet(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationGetAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get count of all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationGetCountGet(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationGetCountGet(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationGetCountGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get recent unread Notifications and total count of unread notifications.
         * @param {string} version 
         * @param {number} [count] How many recent notifications to get. Insert UserEntity Header (Partition Key)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationGetRecentGet(version: string, count?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationGetRecentGet(version, count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationGetRecentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a single notification by primary key. Sort Key (timestamp) Partition Key (user entity header)\"  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {string} [timestamp] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationKeyGet(version: string, timestamp?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationKeyGet(version, timestamp, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationKeyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks all unread notifications as read
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationMarkAllAsReadPut(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationMarkAllAsReadPut(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationMarkAllAsReadPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks one notification as read
         * @param {string} version 
         * @param {string} [body] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationMarkItemAsReadPut(version: string, body?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationMarkItemAsReadPut(version, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationMarkItemAsReadPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks a list of notifications as read
         * @param {string} version 
         * @param {Array<string>} [requestBody] List of notifications to mark as read. Insert UserEntity Header (Partition Key). Insert timestamps (sortkeys) as list of strings. Example: [\&quot;2025-05-23T13:43:41.8220222+00:00\&quot;]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationMarkListAsReadPut(version: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationMarkListAsReadPut(version, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationMarkListAsReadPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Posts notifications from notification processing lambda. We use these to check for active users.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationPushNewPost(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationPushNewPost(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationPushNewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Notification\'s pagination. Does skip and take based on pageNum and pageSize.
         * @param {string} version 
         * @param {number} [pageNum] Insert UserEntity Header (Partition Key)
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionNotificationSkipAndTakeGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionNotificationSkipAndTakeGet(version, pageNum, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiVversionNotificationSkipAndTakeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets a list of all ModuleActions as ListOptionDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ListModuleActionGet(options?: RawAxiosRequestConfig): AxiosPromise<ListOptionDTOSearchResponseResponse> {
            return localVarFp.apiV1ListModuleActionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of all modules as ListOptionDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ListModuleGet(options?: RawAxiosRequestConfig): AxiosPromise<ListOptionDTOSearchResponseResponse> {
            return localVarFp.apiV1ListModuleGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of ModuleActions for a specific module as ListOptionDTO
         * @param {string} module 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ListModuleModuleActionGet(module: string, options?: RawAxiosRequestConfig): AxiosPromise<ListOptionDTOSearchResponseResponse> {
            return localVarFp.apiV1ListModuleModuleActionGet(module, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of all ModuleActions from all modules (flat structure)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ModuleActionFlatGet(options?: RawAxiosRequestConfig): AxiosPromise<ModuleActionListResponse> {
            return localVarFp.apiV1ModuleActionFlatGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of all ModuleActions for a specific module (flat structure)
         * @param {string} module 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ModuleActionFlatModuleGet(module: string, options?: RawAxiosRequestConfig): AxiosPromise<ModuleActionListResponse> {
            return localVarFp.apiV1ModuleActionFlatModuleGet(module, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all modules with their nested actions in a hierarchical structure  Returns: Module { name, labelKey, id, isDeleted, actions: [{ actionKey, labelKey, active, id, isDeleted }] }
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ModuleActionGet(options?: RawAxiosRequestConfig): AxiosPromise<ModuleWithActionsDTOListResponse> {
            return localVarFp.apiV1ModuleActionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a specific module with its nested actions in a hierarchical structure  Returns: Module { name, labelKey, id, isDeleted, actions: [{ actionKey, labelKey, active, id, isDeleted }] }
         * @param {string} module 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ModuleActionModuleGet(module: string, options?: RawAxiosRequestConfig): AxiosPromise<ModuleWithActionsDTOResponse> {
            return localVarFp.apiV1ModuleActionModuleGet(module, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of all modules from the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ModuleGet(options?: RawAxiosRequestConfig): AxiosPromise<ModuleListResponse> {
            return localVarFp.apiV1ModuleGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all modules with their actions, each action containing its config and schema  Returns a hierarchical structure organized by Module -> ModuleAction -> {Config, Schema}
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ModuleGetAllActionsConfigAndSchemaGet(options?: RawAxiosRequestConfig): AxiosPromise<ModuleActionConfigAndSchemaResponseResponse> {
            return localVarFp.apiV1ModuleGetAllActionsConfigAndSchemaGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Web Socket on connect endpoint.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionConnectionsOnConnectPost(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ObjectResponse> {
            return localVarFp.apiVversionConnectionsOnConnectPost(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Web Socket on disConnect endpoint.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionConnectionsOnDisconnectPost(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ObjectResponse> {
            return localVarFp.apiVversionConnectionsOnDisconnectPost(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a notification configuration for a specific action key
         * @param {string} version 
         * @param {UpdateActionKeyConfig} [updateActionKeyConfig] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationConfigActionPut(version: string, updateActionKeyConfig?: UpdateActionKeyConfig, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionNotificationConfigActionPut(version, updateActionKeyConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all notification configurations and schemas for the current tenant
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationConfigAllGet(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ConfigAndSchemaResponseResponse> {
            return localVarFp.apiVversionNotificationConfigAllGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the entire notification configuration root
         * @param {string} version 
         * @param {UpdateEntireConfig} [updateEntireConfig] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationConfigConfigurationPut(version: string, updateEntireConfig?: UpdateEntireConfig, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionNotificationConfigConfigurationPut(version, updateEntireConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets notification configuration and schema for a specific action ID
         * @param {string} module 
         * @param {string} actionId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationConfigModuleActionIdActionGet(module: string, actionId: string, version: string, options?: RawAxiosRequestConfig): AxiosPromise<ActionConfigAndSchemaResponseResponse> {
            return localVarFp.apiVversionNotificationConfigModuleActionIdActionGet(module, actionId, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets notification configurations and schemas for a specific module
         * @param {string} module 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationConfigModuleGet(module: string, version: string, options?: RawAxiosRequestConfig): AxiosPromise<ModuleConfigAndSchemaResponseResponse> {
            return localVarFp.apiVversionNotificationConfigModuleGet(module, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates all notification configurations for an entire module
         * @param {string} version 
         * @param {UpdateModuleConfig} [updateModuleConfig] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationConfigModulePut(version: string, updateModuleConfig?: UpdateModuleConfig, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionNotificationConfigModulePut(version, updateModuleConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationGetAllGet(version: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationSearchResponseResponse> {
            return localVarFp.apiVversionNotificationGetAllGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get count of all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationGetCountGet(version: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationSearchResponseResponse> {
            return localVarFp.apiVversionNotificationGetCountGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get recent unread Notifications and total count of unread notifications.
         * @param {string} version 
         * @param {number} [count] How many recent notifications to get. Insert UserEntity Header (Partition Key)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationGetRecentGet(version: string, count?: number, options?: RawAxiosRequestConfig): AxiosPromise<NotificationSearchResponseResponse> {
            return localVarFp.apiVversionNotificationGetRecentGet(version, count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a single notification by primary key. Sort Key (timestamp) Partition Key (user entity header)\"  Insert UserEntity Header (Partition Key)
         * @param {string} version 
         * @param {string} [timestamp] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationKeyGet(version: string, timestamp?: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationResponse> {
            return localVarFp.apiVversionNotificationKeyGet(version, timestamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks all unread notifications as read
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationMarkAllAsReadPut(version: string, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionNotificationMarkAllAsReadPut(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks one notification as read
         * @param {string} version 
         * @param {string} [body] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationMarkItemAsReadPut(version: string, body?: string, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionNotificationMarkItemAsReadPut(version, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks a list of notifications as read
         * @param {string} version 
         * @param {Array<string>} [requestBody] List of notifications to mark as read. Insert UserEntity Header (Partition Key). Insert timestamps (sortkeys) as list of strings. Example: [\&quot;2025-05-23T13:43:41.8220222+00:00\&quot;]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationMarkListAsReadPut(version: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionNotificationMarkListAsReadPut(version, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Posts notifications from notification processing lambda. We use these to check for active users.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationPushNewPost(version: string, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionNotificationPushNewPost(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Notification\'s pagination. Does skip and take based on pageNum and pageSize.
         * @param {string} version 
         * @param {number} [pageNum] Insert UserEntity Header (Partition Key)
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionNotificationSkipAndTakeGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<NotificationSearchResponseResponse> {
            return localVarFp.apiVversionNotificationSkipAndTakeGet(version, pageNum, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @summary Gets a list of all ModuleActions as ListOptionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1ListModuleActionGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1ListModuleActionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of all modules as ListOptionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1ListModuleGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1ListModuleGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of ModuleActions for a specific module as ListOptionDTO
     * @param {string} module 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1ListModuleModuleActionGet(module: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1ListModuleModuleActionGet(module, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of all ModuleActions from all modules (flat structure)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1ModuleActionFlatGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1ModuleActionFlatGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of all ModuleActions for a specific module (flat structure)
     * @param {string} module 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1ModuleActionFlatModuleGet(module: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1ModuleActionFlatModuleGet(module, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all modules with their nested actions in a hierarchical structure  Returns: Module { name, labelKey, id, isDeleted, actions: [{ actionKey, labelKey, active, id, isDeleted }] }
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1ModuleActionGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1ModuleActionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a specific module with its nested actions in a hierarchical structure  Returns: Module { name, labelKey, id, isDeleted, actions: [{ actionKey, labelKey, active, id, isDeleted }] }
     * @param {string} module 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1ModuleActionModuleGet(module: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1ModuleActionModuleGet(module, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of all modules from the database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1ModuleGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1ModuleGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all modules with their actions, each action containing its config and schema  Returns a hierarchical structure organized by Module -> ModuleAction -> {Config, Schema}
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1ModuleGetAllActionsConfigAndSchemaGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1ModuleGetAllActionsConfigAndSchemaGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Web Socket on connect endpoint.
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionConnectionsOnConnectPost(version: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionConnectionsOnConnectPost(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Web Socket on disConnect endpoint.
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionConnectionsOnDisconnectPost(version: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionConnectionsOnDisconnectPost(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a notification configuration for a specific action key
     * @param {string} version 
     * @param {UpdateActionKeyConfig} [updateActionKeyConfig] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationConfigActionPut(version: string, updateActionKeyConfig?: UpdateActionKeyConfig, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationConfigActionPut(version, updateActionKeyConfig, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all notification configurations and schemas for the current tenant
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationConfigAllGet(version: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationConfigAllGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the entire notification configuration root
     * @param {string} version 
     * @param {UpdateEntireConfig} [updateEntireConfig] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationConfigConfigurationPut(version: string, updateEntireConfig?: UpdateEntireConfig, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationConfigConfigurationPut(version, updateEntireConfig, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets notification configuration and schema for a specific action ID
     * @param {string} module 
     * @param {string} actionId 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationConfigModuleActionIdActionGet(module: string, actionId: string, version: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationConfigModuleActionIdActionGet(module, actionId, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets notification configurations and schemas for a specific module
     * @param {string} module 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationConfigModuleGet(module: string, version: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationConfigModuleGet(module, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates all notification configurations for an entire module
     * @param {string} version 
     * @param {UpdateModuleConfig} [updateModuleConfig] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationConfigModulePut(version: string, updateModuleConfig?: UpdateModuleConfig, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationConfigModulePut(version, updateModuleConfig, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationGetAllGet(version: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationGetAllGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get count of all Notifications by UserEntity  Insert UserEntity Header (Partition Key)
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationGetCountGet(version: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationGetCountGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get recent unread Notifications and total count of unread notifications.
     * @param {string} version 
     * @param {number} [count] How many recent notifications to get. Insert UserEntity Header (Partition Key)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationGetRecentGet(version: string, count?: number, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationGetRecentGet(version, count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a single notification by primary key. Sort Key (timestamp) Partition Key (user entity header)\"  Insert UserEntity Header (Partition Key)
     * @param {string} version 
     * @param {string} [timestamp] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationKeyGet(version: string, timestamp?: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationKeyGet(version, timestamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks all unread notifications as read
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationMarkAllAsReadPut(version: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationMarkAllAsReadPut(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks one notification as read
     * @param {string} version 
     * @param {string} [body] Notification to mark as read. Insert UserEntity Header (Partition Key). Insert timestamp (sort key) as a string. Example: \&quot;2025-05-23T13:43:41.8220222+00:00\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationMarkItemAsReadPut(version: string, body?: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationMarkItemAsReadPut(version, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks a list of notifications as read
     * @param {string} version 
     * @param {Array<string>} [requestBody] List of notifications to mark as read. Insert UserEntity Header (Partition Key). Insert timestamps (sortkeys) as list of strings. Example: [\&quot;2025-05-23T13:43:41.8220222+00:00\&quot;]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationMarkListAsReadPut(version: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationMarkListAsReadPut(version, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Posts notifications from notification processing lambda. We use these to check for active users.
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationPushNewPost(version: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationPushNewPost(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Notification\'s pagination. Does skip and take based on pageNum and pageSize.
     * @param {string} version 
     * @param {number} [pageNum] Insert UserEntity Header (Partition Key)
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiVversionNotificationSkipAndTakeGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiVversionNotificationSkipAndTakeGet(version, pageNum, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}

